import unpin from '../../../../assets/img/svg/colum-order/unpin.svg';
import pin from '../../../../assets/img/svg/colum-order/pin.svg';
import { Opacity } from '../../../../enum/Opacity';
import { useColumnDragDrop } from '../../../../hook/useColumnDragDrop';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { togglePin, toggleVisible } from '../../../../store/slice/config/config';
import { t } from 'i18next';
import { useAppSelector } from '../../../../hook/useAppSelector';

interface ColumnOrderRowOptionsProps {
  column: any;
  index: number;
}

const ColumnOrderRowOptions: React.FC<ColumnOrderRowOptionsProps> = ({ column, index }) => {
  const { ref, isDragging } = useColumnDragDrop({
    column,
  });
  const pageKey = useAppSelector((state) => state.configSlice.activePageKey);
  const dispatch = useAppDispatch();

  return (
    <div
      ref={ref}
      key={column.name}
      className={`options_list ${isDragging ? 'dragging' : ''}`}
      style={{
        opacity: isDragging ? Opacity.DRAGGING : Opacity.DEFAULT,
        touchAction: 'manipulation',
      }}
    >
      <img
        className="pin_icon"
        src={column.isPinned ? pin : unpin}
        alt={'Pinned'}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            togglePin({
              pageKey,
              columnName: column.name,
            }),
          );
        }}
      />

      <div
        key={index}
        className="option_checkbox"
        onClick={() => {
          dispatch(
            toggleVisible({
              pageKey,
              columnName: column.name,
            }),
          );
        }}
      >
        <input type="checkbox" checked={column.isVisible ?? false} readOnly />
        <div className="option">
          <span>{t(`columns.${column.name}`)}</span>
        </div>
      </div>
      <div
        className="drag_drop_lines"
        style={{
          opacity: isDragging ? Opacity.DRAGGING : Opacity.DEFAULT,
          cursor: 'move',
        }}
      >
        <hr />
        <hr />
      </div>
    </div>
  );
};

export default ColumnOrderRowOptions;
